import { v4 as uuidv4 } from 'uuid';

const RE_NO_DASH = /-/g;

export const generateId = () => {
  return `${uuidv4().replace(RE_NO_DASH, '')}`;
};
